import { ApiClient } from "../ApiClient";

/**
 * Fetches the synchronization state milestones for all financial institutions.
 */
export const getInstitutionSyncStates = async () => {
  const res = await ApiClient.get("/finances/institution");
  return await res.json();
};
